import axios from 'axios'
import _get from 'lodash/get'

export const FOREIGN_INCOME_UPDATE = 'FOREIGN_INCOME_UPDATE'
export const FOREIGN_INCOME_SAVING = 'FOREIGN_INCOME_SAVING'
export const FOREIGN_INCOME_SAVE_SUCCESS = 'FOREIGN_INCOME_SAVE_SUCCESS'
export const FOREIGN_INCOME_SAVE_ERROR = 'FOREIGN_INCOME_SAVE_ERROR'

export const getForeignIncomes = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/foreignIncomes?selfAssessmentId=${selfAssessmentId}`)
        .then((response) => {
            dispatch(
                updateForeignIncome({
                    shouldFetch: false,
                    fetchSuccessful: true,
                    selfAssessmentId,
                    foreignIncomes: response.data,
                })
            )
        })
        .catch(() => {})
}

export const updateForeignIncome = (foreignIncome) => ({
    type: FOREIGN_INCOME_UPDATE,
    foreignIncome,
})

export const addForeignIncome = (newForeignIncome) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    foreignIncome.foreignIncomes.push(newForeignIncome)

    dispatch(updateForeignIncome(foreignIncome))
}

export const removeForeignIncome = (id) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const newForeignIncomes = foreignIncome.foreignIncomes.filter((o) => o.id !== id)

    dispatch(updateForeignIncome({ foreignIncomes: newForeignIncomes }))
}

export const deleteForeignIncome = (id) => (dispatch) => {
    axios
        .delete(`/foreignIncome/${id}`)
        .then(() => {
            dispatch(removeForeignIncome(id))
        })
        .catch(() => {})
}

export const removeAndDeleteForeignIncome = (id) => (dispatch) => {
    dispatch(removeForeignIncome(id))
    dispatch(deleteForeignIncome(id))
}

export const saveForeignIncome = () => (dispatch, getState) => {
    const { foreignIncome } = getState()

    dispatch(foreignIncomeSaving, foreignIncome)

    axios
        .post('/foreignincomes/', foreignIncome.foreignIncomes)
        .then((response) => {
            dispatch(foreignIncomeSaveSuccess({ foreignIncomes: response.data }))
        })
        .catch((error) => {
            dispatch(foreignIncomeSaveError(foreignIncome, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveForeignIncome = (foreignIncome) => (dispatch) => {
    dispatch(updateForeignIncome(foreignIncome))
    dispatch(saveForeignIncome())
}

export const foreignIncomeSaving = (foreignIncome) => ({
    type: FOREIGN_INCOME_SAVING,
    foreignIncome,
})

export const foreignIncomeSaveSuccess = (foreignIncome) => ({
    type: FOREIGN_INCOME_SAVE_SUCCESS,
    foreignIncome,
})

export const foreignIncomeSaveError = (foreignIncome, errorResponse) => ({
    type: FOREIGN_INCOME_SAVE_ERROR,
    foreignIncome,
    errorResponse,
})

export const saveForeignIncomeStatus = (data) => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const { selfAssessmentId, foreignIncomeSummary } = foreignIncome

    axios
        .put(`/foreignincomesummary/${selfAssessmentId}`, {
            ...foreignIncomeSummary,
            selfAssessmentId,
            status: data.status,
        })
        .catch(() => {})
}

export const updateAndSaveForeignIncomeSummary = (data) => (dispatch) => {
    dispatch(updateForeignIncome({ foreignIncomeSummary: data }))
    dispatch(saveForeignIncomeSummary())
}

export const saveForeignIncomeSummary = () => (dispatch, getState) => {
    const { foreignIncome } = getState()

    const { selfAssessmentId, foreignIncomeSummary } = foreignIncome

    axios
        .put(`/foreignincomesummary/${selfAssessmentId}`, { ...foreignIncomeSummary, selfAssessmentId })
        .then((response) => {
            dispatch(foreignIncomeSaveSuccess({ foreignIncomeSummary: response.data }))
        })
        .catch((error) => {
            dispatch(foreignIncomeSaveError(foreignIncome, _get(error, ['response', 'data'])))
        })
}

export const getForeignIncomeSummary = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/foreignincomesummary/${selfAssessmentId}`)
        .then((response) => {
            dispatch(updateForeignIncome({ foreignIncomeSummary: response.data }))
        })
        .catch(() => {})
}
